import React from "react";


const PrintPage = ({ printPage }) => {

  return <div className="print-page">
    {printPage}
  </div>;
};
export {
  PrintPage,
};
export default PrintPage;
